import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SiteContentContext = createContext(null);
const API = process.env.REACT_APP_BACKEND_URL;

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/site-content`).then(r => setContent(r.data)).catch(() => setContent({}));
  }, []);

  return (
    <SiteContentContext.Provider value={content}>
      {children}
    </SiteContentContext.Provider>
  );
}

export function useSiteContent() {
  return useContext(SiteContentContext);
}
